import { auth } from '../firebase';

/** Retorna ID token Firebase atualizado (renova se a sessão estiver ativa). */
export async function getFirebaseAuthToken() {
  if (auth?.currentUser) {
    try {
      const fresh = await auth.currentUser.getIdToken();
      localStorage.setItem('token', fresh);
      return fresh;
    } catch (e) {
      console.warn('getFirebaseAuthToken: falha ao renovar token', e);
    }
  }
  return localStorage.getItem('token') || null;
}
